// Чистый маппинг ошибок бэкенда на человекочитаемый русский.
// Используется в errorHandler.js (тостеры) и apiStorage.js (formErrors).

const STATUS_MESSAGES = {
  400: 'Некорректный запрос',
  401: 'Сессия истекла, войдите заново',
  403: 'Недостаточно прав для этого действия',
  404: 'Ресурс не найден',
  405: 'Метод не поддерживается',
  409: 'Конфликт: запись уже существует или используется',
  422: 'Проверьте правильность заполнения полей',
  429: 'Слишком много запросов, попробуйте позже',
  500: 'Внутренняя ошибка сервера, попробуйте позже',
  502: 'Сервис недоступен, попробуйте позже',
  503: 'Сервис временно недоступен',
  504: 'Превышено время ожидания ответа сервера',
}

// Известные сырые строки бэкенда → русский. Ключи в нижнем регистре.
const DETAIL_MESSAGES = {
  'unauthorized': 'Сессия истекла, войдите заново',
  'not authenticated': 'Сессия истекла, войдите заново',
  'credentials are invalid': 'Неверный логин или пароль',
  'could not validate credentials': 'Сессия истекла, войдите заново',
  'forbidden': 'Недостаточно прав для этого действия',
  'not found': 'Ресурс не найден',
  'internal server error': 'Внутренняя ошибка сервера',
  'conflict': 'Конфликт: запись уже существует или используется',
}

// Типовые pydantic-сообщения валидации полей → русский.
const FIELD_MESSAGES = {
  'none is not an allowed value': 'Поле обязательно для заполнения',
  'value is not a valid integer': 'Ожидается число',
  'value is not a valid email address': 'Некорректный email',
  'string does not match regex pattern': 'Неверный формат значения',
}

// Pydantic v1 оборачивает ValueError в "Value error, <текст>" — снимаем обёртку.
export function translateFieldMessage(msg) {
  if (!msg) return 'Ошибка заполнения'
  const clean = String(msg).trim()
  const valueError = /^Value error,\s*/i.exec(clean)
  const bare = valueError ? clean.slice(valueError[0].length) : clean
  const lower = bare.toLowerCase()
  return FIELD_MESSAGES[lower] || bare
}

export function translateDetail(detail) {
  if (!detail) return ''
  if (typeof detail === 'string') {
    const lower = detail.trim().toLowerCase()
    return DETAIL_MESSAGES[lower] || detail
  }
  if (typeof detail === 'object' && detail.message) {
    return translateDetail(detail.message)
  }
  return ''
}

const CYRILLIC = /[А-Яа-яЁё]/

export const NETWORK_MESSAGE =
  'Не удалось связаться с сервером. Проверьте интернет и повторите через минуту. Если не помогло — сообщите в IT.'
export const TIMEOUT_MESSAGE = 'Сервер слишком долго не отвечает. Повторите через минуту.'
export const OFFLINE_MESSAGE = 'Нет подключения к интернету на этом компьютере.'

// Ответа от сервера нет совсем: интернет пропал, запрос не дождался ответа
// или сервер был недоступен.
export function noResponseMessage(error) {
  if (typeof navigator !== 'undefined' && navigator && navigator.onLine === false) {
    return OFFLINE_MESSAGE
  }
  const code = error?.code
  if (code === 'ECONNABORTED' || code === 'ETIMEDOUT') return TIMEOUT_MESSAGE
  return NETWORK_MESSAGE
}

export function isCancelError(error) {
  return Boolean(
    error && (error.__CANCEL__ || error.code === 'ERR_CANCELED' ||
      error.name === 'CanceledError' || error.name === 'AbortError'),
  )
}

export function statusMessage(status) {
  return STATUS_MESSAGES[status] || 'Ошибка при выполнении запроса'
}

// Итоговое сообщение для показа пользователю: перевод detail, иначе — по статусу.
export function humanizeApiError(error) {
  const status = error?.response?.status
  if (!status) return noResponseMessage(error)
  const detail = error.response.data?.detail
  if (Array.isArray(detail)) {
    return STATUS_MESSAGES[422]
  }
  const translated = translateDetail(detail)
  // Технический английский текст (трейсы, ответы сторонних сервисов)
  // пользователю не показываем — только понятное сообщение по коду.
  if (translated && CYRILLIC.test(translated)) return translated
  return statusMessage(status)
}

// Для axios-интерсептора: компоненты часто показывают error.message —
// подменяем английское "Network Error" / "Request failed with status code 500"
// на русский текст, а исходный сохраняем для отладки.
export function humanizeAxiosError(error) {
  if (!error || typeof error !== 'object' || isCancelError(error)) return error
  if (error.technicalMessage === undefined) error.technicalMessage = error.message
  error.message = humanizeApiError(error)
  return error
}
